export const BlockOutlink = (props) => {
    const { items } = props;
    const link_href = items.link_href ? items.link_href : '#';
    const link_name = items.link_name ? items.link_name : 'aucun';
    return (
        <a className="link" href={link_href} target="_blank" rel="noreferrer" >
            <div className="code"><i className="fa fa-link"></i></div>
            <div className="name">{`Source: ${link_name}`}</div>
        </a>
    )
}